import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class OpportunitiesService {
  constructor(private http: HttpClientService) {}

  public put(id: number | string, options: any): Observable<any> {
    return this.http
      .put("/api/opportunities/" + id, options)
      .pipe(tap((_) => console.log("OpportunitiesService.put: Ok.")));
  }
}
